import React, { useContext, useEffect, useState } from "react";
import { AuthFetch } from "../../services/api";
import { UserContext } from "../../context/provider/UserProvider";
import { notify } from "../../utils/utils";

const urlBaseUnidades = process.env.REACT_APP_TMAN_API + '/Unit'

export const useUnidades = () => {
    const { stateUser , signOut } = useContext(UserContext);
    const codEmpresa = stateUser.codEmpresa

    const [unidadesActivas,setUnidadesActivas] = useState([])
    const [unidadesSinOT,setUnidadesSinOT] = useState([])
    
    const listadoUnidadesActivas = async () => {
        const response = await AuthFetch({
            url: urlBaseUnidades + '?' + new URLSearchParams({
                codEmpresa: codEmpresa
            })
        })
        if(response.isValid){
            setUnidadesActivas(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }

    const listaUnidadesSinOT = async () => {
        const response = await AuthFetch({
            url: urlBaseUnidades + '/combo?' + new URLSearchParams({
                codEmpresa: codEmpresa
            })
        })
        if(response.isValid){
            setUnidadesSinOT(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }
    
    
    return {
        unidadesActivas,
        listadoUnidadesActivas,
        unidadesSinOT,
        listaUnidadesSinOT
    }
};
